import React from "react";
import styles from "./style.module.css";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

class App extends React.PureComponent {
  render() {
    const { children, isTableauMode, isConsumerMode, location } = this.props;

    return isTableauMode ? (
      <div className={styles.tableauApp}>
        <div className={styles.tableauMode}>{children}</div>
      </div>
    ) : isConsumerMode ? (
      <div className={styles.app + " " + styles.tApp}>
        <div className={styles.tabApp}>{children}</div>
      </div>
    ) : (
      <div className={styles.app} id="mainApp">
        {children}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({});

const mapStateToProps = (state, ownProps) => ({});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withRouter, withConnect)(App);
